import { parseISO, format } from "date-fns";
import { CalendarSVG } from "@/components/svg";

export default function Date({ dateString }) {
  const date = parseISO(dateString);
  return (
    <div className="grid grid-cols-[20px_auto] items-center gap-x-4">
      <CalendarSVG className="mr-3 text-subheading-gray w-[20px] h-[20px]" />
      <div className="font-normal text-subheading-gray">
        {format(date, "LLLL	d, yyyy")}
      </div>
    </div>
  );
}
